import { render, staticRenderFns } from "./Credit.vue?vue&type=template&id=32d4ce87&scoped=true&"
import script from "./Credit.vue?vue&type=script&lang=js&"
export * from "./Credit.vue?vue&type=script&lang=js&"
import style0 from "./Credit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Credit.vue?vue&type=style&index=1&id=32d4ce87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4ce87",
  null
  
)

export default component.exports